import { FC } from "react"
import { Button } from "@unlimint/admin-ui-kit"

import { FormError } from "view/components/FormError"

import * as S from "./styled"

type TConfirmBackProps = {
  error: unknown | null
  isSubmitting: boolean
  onCancel(): void
  onSubmit(): void
  onBack(): void
}

export const ConfirmBack: FC<TConfirmBackProps> = ({
  error,
  isSubmitting,
  onCancel,
  onSubmit,
  onBack,
}) => {
  return (
    <S.Wrapp>
      <S.Title>Do you want to save changes before leave page?</S.Title>

      <S.ButtonsBlock>
        <Button size="small" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="small" color="secondary" onClick={onBack}>
          Don’t save and leave
        </Button>
        <Button
          size="small"
          type="submit"
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          Save and leave
        </Button>
      </S.ButtonsBlock>

      <FormError error={error} align="center" />
    </S.Wrapp>
  )
}
